export const managers = [
    {
        id: 'Вероника',
        avatar: 'ceo.jpg',
        text: `<ul>
<li>Я люблю путешествовать и хочу помочь другим людям увидеть мир.</li>
<li>Я уверена, что путешествия делают нас счастливее и помогают нам стать лучше.</li>
 <li>Я всегда готова помочь вам с выбором тура и ответить на все ваши вопросы.</li>
  <li>Приходите к нам в офис или звоните, и мы подберем для вас лучший тур. Я жду вас!</li>
  </ul>`,
        contacts: [
            {
                id: 'phone',
                icon: 'phone.svg',
                value: '+375445389727',
                action: 'tel:'
            },
        ],
    },
    {
        id: 'Татьяна',
        avatar: 'manager1.jpg',
        text: `<ul>
<li>В туризме с <b>2007</b> года.</li>
<li>Десятки рекламных туров и более <b>20</b> изведанных стран за плечами!</li>
<li>Для меня туризм – это не только работа, но и <b>любимое дело</b>!</li>
<li>Стараюсь для <b>каждого из вас</b> быть максимально полезной, дать нужную информацию и поделиться своими знаниями.</li>
<li>Главная задача – организовать своим клиентам <b>запоминающийся отдых</b> и оправдать ожидания.</li>
</ul>`,
        contacts: [
            {
                id: 'phone',
                icon: 'phone.svg',
                value: '+375445997546',
                action: 'tel:'
            },
        ],
    },
    {
        id: 'Ольга',
        avatar: 'manager2.jpg',
        text: `<ul>
<li>Семья и любимая работа - вот мой простой секрет счастья!</li>
<li>Туризму я посвятила себя в 2009 году! И до сих пор каждый день я <b>обожаю свою работу</b>, потому что дарю людям <b>незабываемые эмоции от отдыха!</b></li>
<li>Для меня нет ничего лучше, чем <b>ваши счастливые глаза</b> и прекрасные отзывы после вашего отдыха 🥰</li>
<li>Всегда рада своим <b>любимым постоянным и новым клиентам</b>🤗✈️</li></ul>`,
        contacts: [
            {
                id: 'phone',
                icon: 'phone.svg',
                value: '+375296862900',
                action: 'tel:'
            },
        ],
    },
    {
        id: 'Ангелина',
        avatar: 'manager3.jpg',
        text: `<ul>
<li>Для меня путешествия — это коллекционирование моментов.</li>
<li>Постоянно изучаю отельную базу и тонкости разных направлений, чтобы давать вам <b>только актуальные советы.</b></li>
<li>Знаю изнанку туризма, поэтому честно предупреждаю, <b>на чем можно сэкономить</b>, а где этого делать не стоит.</li>
<li>Ценю долгосрочные отношения, поэтому мне важно не просто «продать тур», а стать вашим <b>личным тревел-экспертом на годы</b>.</li></ul>`,
        contacts: [
            {
                id: 'phone',
                icon: 'phone.svg',
                value: '+375292346450',
                action: 'tel:'
            },
        ],
    },
    {
        id: 'Екатерина',
        avatar: 'manager4.jpg',
        text: `<ul>
<li>Я помогаю превращать мечты о путешествиях в <b>безупречно спланированный отпуск</b>.</li>
<li>Моя главная задача - <b>избавить вас от рутины бесконечного поиска</b> и страха «что-то пойдёт не так».</li>
<li>Помогаю своим туристам открывать мир комфортного отдыха, регулярно посещаю рекламные туры, чтобы детально изучать все нюансы <b>для вашего беззаботного отдыха</b>.</li></ul>`,
        contacts: [
            {
                id: 'phone',
                icon: 'phone.svg',
                value: '+375447667697',
                action: 'tel:'
            },
        ],
    },
];
